import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { ProjectCard, type ProjectCardData } from "~/modules/dashboard/components/ProjectCard.tsx";
import { useActiveStaffings } from "~/modules/dashboard/hooks/useActiveStaffings.ts";
import type { UsersActiveStaffingType } from "~/modules/project/api/staffing/staffingTypes.ts";

function getCards(projects: UsersActiveStaffingType[]): ProjectCardData[] {
	return projects.flatMap((project) =>
		project.projectPhases.flatMap((phase) =>
			phase.orders.flatMap((order) => order.staffings.map((staffing) => ({ project, order, staffing })))));
}

// One card for each staffing, not for each project: two staffings of one project give two cards.
// A staffing that ended in this month keeps its card until the month closing, because it still takes
// trackings for the days of its period until then.
export function ProjectCards() {
	const { data, isPending, isError } = useActiveStaffings();
	const cards = data ? getCards(data.projects) : [];

	return (
		<div>
			<h3 className="mb-3 flex min-h-7 items-center text-lg font-semibold text-gray-900">Meine Projekte</h3>
			{isPending && <LoadingSpinner theme="neutral" />}
			{isError && <p className="text-sm text-gray-500">Die Projekte konnten nicht geladen werden.</p>}
			{data && cards.length === 0 && (
				<p className="text-sm text-gray-500">Du bist aktuell keinem Projekt zugeordnet.</p>
			)}
			{cards.length > 0 && (
				<div className="rounded-lg bg-white p-3 shadow-sm">
					<ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
						{cards.map((card) => <ProjectCard key={card.staffing.id} {...card} />)}
					</ul>
				</div>
			)}
		</div>
	);
}
